module.exports = __webpack_public_path__ + "img/logo.e97162cd.png";